export enum InputType {
  SELECT = 'SELECT',
  TEXT_INPUT = 'TEXT_INPUT',
}
